import { useEffect, useRef } from 'react';
import { App as CapApp } from '@capacitor/app';
import { isAndroid } from '../utils/platformUtils';

// Bouton retour Android. Sans listener, @capacitor/app se rabat sur l'historique de
// la webview : l'app n'ayant pas de router, le retour ne ferme rien de ce qui est
// ouvert et donne l'impression que l'app ne répond pas. On prend donc la main :
// `onBack` ferme la couche la plus haute et rend true, et quand plus rien n'est
// ouvert on quitte, comme n'importe quelle app Android sur son écran racine.
//
// Deux pièges évités ici :
//  - le listener ne s'enregistre qu'une fois. addListener est asynchrone en
//    Capacitor 7, le re-souscrire à chaque rendu empilerait des doublons et une
//    pression fermerait plusieurs couches d'un coup ;
//  - il lit le handler courant dans une ref, sinon il resterait figé sur les états
//    du premier rendu.
//
// Le plugin passe par OnBackPressedDispatcher (AndroidX), donc le geste prédictif
// d'Android 14+ le déclenche aussi : rien à déclarer dans le manifeste.
export function useAndroidBackButton(onBack) {
  const handlerRef = useRef(onBack);
  handlerRef.current = onBack;

  useEffect(() => {
    if (!isAndroid()) return undefined;

    let remove = null;
    let cancelled = false;

    CapApp.addListener('backButton', () => {
      if (handlerRef.current?.()) return;
      CapApp.exitApp();
    }).then((listener) => {
      // Démontage avant que la promesse ne résolve : on retire tout de suite.
      if (cancelled) {
        listener.remove();
        return;
      }
      remove = () => listener.remove();
    });

    return () => {
      cancelled = true;
      remove?.();
    };
  }, []);
}

export default useAndroidBackButton;
